module.exports = {"1":"Positiva","2":"Positiva con correcciones","3":"Negativa"};